<div class="top-banner">
  <div class="top-banner_welcome">
    <p>
      Welcome Back, <strong> {{ userName }}</strong>
    </p>
    <img src="assets/images/Waving Hand.svg" alt="" />
  </div>
  <div class="top-banner_actions">
    <!-- <p-button
      icon="pi pi-bell"
      class="notification-icon"
      [text]="true"
      (click)="toggleNotifications()"
    >
    </p-button> -->

    <p-speedDial
      [model]="[]"
      direction="up"
      transitionDelay="80"
      showIcon="pi pi-bell"
      hideIcon="pi pi-bell"
      buttonClassName="p-button-outlined"
      (onVisibleChange)="toggleNotifications()"
    />

    @if (showNotifications) {
    <stc-apps-notifications-list
      [ngStyle]="
        notifications.length > 0 ? { right: '0', minWidth: '25rem' } : {}
      "
      [notifications]="notifications"
    ></stc-apps-notifications-list>
    }
    <stc-apps-header
      [userName]="userName"
      [logoSrc]="logoSrc()"
      [allItems]="[]"
      [sidebarLogoSrc]="logoSrc()"
      [showLang]="false"
      (logOut)="handleLogOut()"
    ></stc-apps-header>
  </div>
</div>
